import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
  },
  title: {
    marginTop: theme.spacing(0.5),
    fontSize: 20,
    color: 'black',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
    marginBottom: theme.spacing(2),
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 40,
    width: '550px',
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  actionBtn: {
    width: '40%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  cancelButton: {
    width: '50%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
}));
